import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import { cambiarCompartirEmailAsync } from "@/services/InscripcionesService";
import { useToast } from "@/composables/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'InterruptorCompartirEmail',
  props: {
    idInscripcion: {},
    valor: { type: [Boolean, null] }
  },
  setup(__props: any) {

const props = __props;

const { triggerToast } = useToast();
const compartir = ref(!!props.valor);
const guardando = ref(false);

const cambiar = async (valor: boolean | null) => {
  const nuevo = !!valor;
  guardando.value = true;
  try {
    await cambiarCompartirEmailAsync(props.idInscripcion, nuevo);
    compartir.value = nuevo;
    triggerToast(
      "success",
      nuevo
        ? "El organizador ya puede ver tu correo"
        : "El organizador ya no ve tu correo"
    );
  } catch (error) {
    console.error(error);
    triggerToast("error", "No se ha podido cambiar");
  } finally {
    guardando.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createBlock(_component_v_switch, {
    "model-value": compartir.value,
    color: "primary",
    density: "compact",
    inset: "",
    "hide-details": "auto",
    loading: guardando.value,
    disabled: guardando.value,
    label: "Compartir mi correo con el organizador",
    messages: 
      compartir.value
        ? 'El organizador puede verlo para contactarte si hace falta.'
        : 'El organizador no ve tu correo.'
    ,
    "onUpdate:modelValue": cambiar
  }, null, 8, ["model-value", "loading", "disabled", "messages"]))
}
}

})